import { useMutation, useQuery } from '@tanstack/react-query';

import { useSnackBar } from '@sbv-clients/ui-shared';
import { getApiErrorMessage } from '@sbv-clients/util-misc';

import { ContactSupportRequest, useApi } from '../index';
import { ContactSupportCacheKeys } from './util/cache-keys';

export const useContactSupportPermissionGet = ({
  enabled = true,
}: { enabled?: boolean } = {}) => {
  const api = useApi();
  return useQuery({
    queryKey: [ContactSupportCacheKeys.ContactSupportPermission],
    enabled,
    queryFn: () =>
      api.contactSupportV2Api
        .apiV2ContactSupportPermissionGet()
        .then((response) => response.data ?? {}),
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    staleTime: Infinity,
  });
};

export const useContactSupportSend = () => {
  const api = useApi();
  const { notifyError } = useSnackBar();

  return useMutation(
    (contactSupportRequest: ContactSupportRequest) =>
      api.contactSupportV2Api
        .apiV2ContactSupportPost({ contactSupportRequest })
        .then((response) => response.data),
    {
      onError: async (error) => {
        notifyError(getApiErrorMessage(error));
      },
    }
  );
};
